import strings from '../locale/en'
import ROUTES from './routes'

const teacherAdmin = [
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.admin.publishMaterial,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.PUBLISH_LIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.publish,
        to: ROUTES.PUBLISH_MATERIAL_ADD
      }
    ]
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.admin.assignment,
    to: ROUTES.ASSIGNMENT
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.lessonPlane.title,
    to: ROUTES.LESSON_PLANE,
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.leave.leaveMaster,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.leave.create,
        to: ROUTES.CREATE_LEAVE
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.leave.leaveMasterDetails,
        to: ROUTES.LEAVE_MASTER_DETAILS
      }
    ]
  },
]

const branchAdmin = [
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.admin.user,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.teacher,
        to: ROUTES.TEACHER
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.student,
        to: ROUTES.STUDENT
      }
    ]
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.batch.title,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.BATCH_LIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.batch.add,
        to: ROUTES.BATCH_ADD
      }
    ]
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.admin.publishMaterial,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.PUBLISH_LIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.publish,
        to: ROUTES.PUBLISH_MATERIAL_ADD
      }
    ]
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.admin.session,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.SESSION_LIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.create,
        to: ROUTES.ADD_SESSION
      }
    ]
  }
]

const institudeAdmin = [
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.admin.user,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.branchAdmin,
        to: ROUTES.BRANCHADMIN
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.teacher,
        to: ROUTES.TEACHER
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.student,
        to: ROUTES.STUDENT
      }
    ]
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.branch.title,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.BRANCH_LIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.branch.add,
        to: ROUTES.BRANCH_ADD
      }
    ]
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.batch.title,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.BATCH_LIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.batch.add,
        to: ROUTES.BATCH_ADD
      }
    ]
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.admin.publishMaterial,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.PUBLISH_LIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.publish,
        to: ROUTES.PUBLISH_MATERIAL_ADD
      }
    ]
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.admin.session,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.SESSION_LIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.create,
        to: ROUTES.ADD_SESSION
      }
    ]
  }
]

const student = [
  {
    icon: ['fas', 'book'],
    label: strings.menu.student.learn,
    to: ROUTES.LEARN
  }, 
  {
    icon: ['fas', 'qrcode'],
    label: strings.menu.student.webcam,
    to: ROUTES.WEBCAM_SCANNER
  },
  {
    icon: ['fas', 'laptop'],
    label: strings.menu.student.live,
    to: ROUTES.LIVE
  },
  {
    icon: ['fas', 'file-pen'],
    label: strings.menu.student.practiceTest,
    to: ROUTES.PRACTICE_TEST
  },
 {
    icon: ['fas', 'user-pen'],
    label: strings.menu.student.assessment,
    to: ROUTES.ASSESSMENT
  }
]

const admin = [
  {
    icon: ['far', 'bar-chart'],
    label: strings.menu.admin.dashboard,
    to: ROUTES.DASHBOARD
  },
  {
    icon: ['fas', 'users'],
    label: strings.menu.admin.user,
    to: '',
    childs: [
      {
        icon: ['fas', 's'],
        label: strings.menu.admin.superAdmin,
        to: ROUTES.SUPERADMIN
      },
      {
        icon: ['fas', 'b'],
        label: strings.menu.admin.branchAdmin,
        to: ROUTES.BRANCHADMIN
      },
      {
        icon: ['fas', 'i'],
        label: strings.menu.admin.institudeAdmin,
        to: ROUTES.INSTITUTEADMIN
      },
      {
        icon: ['fas', 't'],
        label: strings.menu.admin.teacher,
        to: ROUTES.TEACHER
      },
      {
        icon: ['fas', 's'],
        label: strings.menu.admin.student,
        to: ROUTES.STUDENT
      }
    ]
  },
  {
    icon: ['fas', 'laptop-file'],
    label: strings.menu.course.title,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.COURSELIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.course.add,
        to: ROUTES.ADDCOURSE
      }
    ]
  },
  {
    icon: ['fas', 'code-branch'],
    label: strings.menu.branch.title,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.list,
        to: ROUTES.BRANCH_LIST
      },
      {
        icon: ['fas', 'plus'],
        label: strings.menu.branch.add,
        to: ROUTES.BRANCH_ADD
      }
    ]
  },
  {
    icon: ['fas', 'id-badge'],
    label: strings.menu.batch.title,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.BATCH_LIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.batch.add,
        to: ROUTES.BATCH_ADD
      }
    ]
  },
  {
    icon: ['fas', 'building-columns'],
    label: strings.menu.admin.institute,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.INSTITUTE
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.addInstitute,
        to: ROUTES.ADD_INSTITUTE
      }
    ]
  },
  {
    icon: ['fas', 'book-open'],
    label: strings.menu.admin.adminMaterial,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.ADMIN_MATERIAL
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.material.add,
        to: ROUTES.ADD_MATERIAL
      }
    ]
  },
  {
    icon: ['fas', 'file-circle-plus'],
    label: strings.menu.admin.publishMaterial,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.PUBLISH_LIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.publish,
        to: ROUTES.PUBLISH_MATERIAL_ADD
      }
    ]
  },
  {
    icon: ['fas', 'hourglass-end'],
    label: strings.menu.admin.session,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.SESSION_LIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.create,
        to: ROUTES.ADD_SESSION
      }
    ]
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.admin.questionBank,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.list,
        to: ROUTES.QUESTIONLIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.addQuestion,
        to: ROUTES.ADDQUESTION
      }
    ]
  },
  {
    icon: ['fas', 'file-pen'],
    label: strings.menu.admin.createTest.title,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.createTest.title,
        to: ROUTES.CREATE_TEST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.createTest.testList,
        to: ROUTES.TEST_LIST
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.createTest.testResults,
        to: ROUTES.TEST_RESULTS
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.createTest.pendingRequests,
        to: ROUTES.PENDING_REQUESTS
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.createTest.evaluate,
        to: ROUTES.EVALUATE
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.admin.createTest.reviewQuestions,
        to: ROUTES.REVIEW
      }
    ]
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.learnSession.title,
    to: ROUTES.LEARN_SESSION,
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: strings.menu.leave.title,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.leave.apply,
        to: ROUTES.APPLY_LEAVE
      },
      {
        icon: ['fas', 'bars'],
        label: strings.menu.leave.details,
        to: ROUTES.LEAVE_DETAILS
      }
    ]
  },
  {
    icon: ['fas', 'qrcode'],
    label: strings.menu.leave.qrcode,
    to: '',
    childs: [
      {
        icon: ['fas', 'bars'],
        label: strings.menu.leave.qrList,
        to: ROUTES.QR_LIST
      }
    ]
  },
  {
    icon: ['fas', 'puzzle-piece'],
    label: 'Clear Cache',
    to: ROUTES.CACHE,
  }
]

const menus = {
  student: student,
  admin: admin,
  branchAdmin: branchAdmin,
  institudeAdmin: institudeAdmin,
  teacherAdmin: teacherAdmin
}

export default menus
